if (!customElements.get('inline-recommendations-slider')) {
  customElements.define(
    'inline-recommendations-slider',
    class InlineRecommendationsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.product-inline-recommendations__track');
        this.previousButton = this.querySelector('.product-inline-recommendations__arrow--prev');
        this.nextButton = this.querySelector('.product-inline-recommendations__arrow--next');

        if (!this.track || !this.previousButton || !this.nextButton) return;

        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        window.addEventListener('resize', () => this.updateButtons(), { passive: true });

        requestAnimationFrame(() => this.updateButtons());
      }

      move(direction) {
        const item = this.track.querySelector('.product-inline-recommendations__item');
        if (!item) return;

        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      updateButtons() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        this.previousButton.disabled = this.track.scrollLeft <= 2;
        this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2 || maxScroll <= 2;
      }
    }
  );
}
